import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../App';
import { CaretLeft } from '@phosphor-icons/react';

const LegalLayout = ({ title, updated, children, testId }) => {
  const { language } = useAuth();
  const L = (en, de) => (language === 'de' ? de : en);
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-5 py-8 sm:py-12" data-testid={testId}>
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-slate-600 hover:text-emerald-700 text-sm font-semibold mb-6"
          data-testid="legal-back"
        >
          <CaretLeft size={16} /> {L('Back to home', 'Zur Startseite')}
        </Link>
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10">
          <div className="mb-6 pb-6 border-b border-slate-200">
            <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight" data-testid="legal-title">
              {title}
            </h1>
            {updated && (
              <p className="text-slate-500 text-sm mt-2" data-testid="legal-updated">
                {L('Last updated', 'Zuletzt aktualisiert')}: {updated}
              </p>
            )}
          </div>
          <article className="legal-content space-y-4 text-slate-700 leading-relaxed">
            {children}
          </article>
        </div>
        <p className="text-center text-xs text-slate-400 mt-6">
          © {new Date().getFullYear()} Padelarena Wädenswil ·{' '}
          <a href="mailto:info@padelarena.ch" className="underline hover:text-emerald-700">
            info@padelarena.ch
          </a>
        </p>
      </div>
    </div>
  );
};

export default LegalLayout;
